// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"
import Twitter from "./twitter"
import Facebook from "./facebook"

interface Props {
  title: string
  lang?: string
  description?: string
  article?: boolean
  image?: string
}

interface Data {
  site: {
    siteMetadata: {
      defaultTitle: string
      defaultDescription: string
      defaultImage: string
      titleTemplate: string
      siteUrl: string
      ogLocale: string
      social: {
        twitterHandle: string
        facebookHandle: string
        fbAppID: string
      }
    }
  }
}

const defaultProps: Props = {
  article: false,
  description: null,
  image: null,
  title: null,
  lang: "en",
}

const SEO: React.FC<Props> = ({ description, image, title, lang }: Props) => {
  const { pathname } = useLocation()
  const { site }: Data = useStaticQuery(query)

  const {
    defaultTitle,
    defaultDescription,
    defaultImage,
    titleTemplate,
    siteUrl,
    social,
    ogLocale,
  } = site.siteMetadata

  const seo = {
    title: title || defaultTitle,
    siteName: defaultTitle,
    lang: lang,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname}`,
    image: `${siteUrl}${image || defaultImage}`,
  }

  return (
    <React.Fragment>
      <Helmet title={seo.title} titleTemplate={titleTemplate}>
        <html lang={seo.lang} />
        <meta name="description" content={seo.description} />
        <meta name="image" content={seo.image} />
      </Helmet>
      <Facebook
        title={titleTemplate.replace(/%s/g, title)}
        desc={seo.description}
        image={seo.image}
        url={seo.url}
        locale={ogLocale}
        siteName={seo.siteName}
        fbAppID={social.fbAppID}
      />
      <Twitter
        title={titleTemplate.replace(/%s/g, title)}
        desc={seo.description}
        image={seo.image}
        username={social.twitterHandle}
      />
    </React.Fragment>
  )
}

SEO.defaultProps = defaultProps

export default SEO

// jamie todo: pull this out into a fragment?
const query = graphql`
  query {
    site {
      siteMetadata {
        defaultAuthor: author
        defaultTitle: title
        defaultDescription: description
        defaultImage: image
        titleTemplate
        siteUrl
        ogLocale
        social {
          twitterHandle
          facebookHandle
          fbAppID
        }
      }
    }
  }
`
